import { render } from "./BlogPostCard.vue?vue&type=template&id=2635e7e0&scoped=true"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"

import "./BlogPostCard.vue?vue&type=style&index=0&id=2635e7e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mehimself.github.io/mehimself.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2635e7e0"]])

export default __exports__